import { takeLatest, put, call, delay } from "redux-saga/effects";
import * as type from "../../redux/types/trans";
import Api from "../../services/trans/trans";
import Dummy from "../../components/organism/transaction/portfolio.json";
import { userTypeList } from "../../helper/constant";
import { FetchFundCategoryNew } from "../../redux/actions/trans/transAction";
import { getDecryptedItem } from "../../helper/methods";
// import schemeDetForSIPDashboard from './getSchemeDetForSIPDashboard.json';

let allApi = new Api();

async function fetchUser(data) {
  let res = await allApi.common(data);
  return res;
}
async function folioList(data) {
  let res = await allApi.common(data);

  return res;
}
async function fetchGet(data) {
  let res = await allApi.commonGet(data);
  return res;
}
async function fetchFundCategory(data) {
  let res = await allApi.CategoryNew(data)
  return res;
}
function* fetchData(action) {
  let getMOH = action.payload;
  // "apiName": "dashboard",
  let payload = {
    apiName: "INAVPortfolioData",
    body: {
      displayZeroFolio: "Y",
      groupBy: "Scheme",
      ...getMOH,
    },
  };
  let foliolistpayload = {
    apiName: "getFolioList",
    body: {},
  };
  let apiresponseFolio = yield call(folioList, foliolistpayload);
  if (apiresponseFolio?.data?.success) {
    let arrayCheck = apiresponseFolio?.data?.data;
    yield put({ type: type.ZBF_FOLIO_SUCCESS, payload: arrayCheck });
  } else {
    yield put({ type: type.ZBF_FOLIO_FAIL, payload: [] });
  }

  if (
    apiresponseFolio.hasOwnProperty("code") &&
    apiresponseFolio.code === 401
  ) {
    // window.location.href = "/";
  }

  let apiresponse = yield call(fetchUser, payload);
  let indexFolioSchemeCode = {};
  let indexSchemename = {};
  let folioData = []; // unique folio number
  let schemeCode = []; // unique schemecode
  let MOHType = []; // unique Hoilding Type
  let portfoliodropDown = []; // dropdown uniqueScheme
  let MOHwiseFolio = {};
  let prefillDropDown = [];
  let getuniqueschemeCode = {};
  let foliowiseholdingtemp = {};
  let folioWiseData = {};
  let folioholdingType = {};
  let portfolioData = null;
  let schemeData = {}; //singleschemeData

  //apiresponse = Dummy;
  if (apiresponse?.data?.success) {
    // if(apiresponse?.data?.data?.portfolios.length === 0){
    //     yield put({
    //         type: type.UPDATE_GUEST_MENU,
    //     })
    // }else{
    //     yield put({
    //         type: type.RESET_GUEST_MENU,
    //     })
    // }
    let getData = apiresponse?.data?.data?.portfolios;
    if (getData) {
      let userType = getData?.[0]?.fhCategory;
      let NRIflag = getData.some(data => userTypeList.includes(data?.fhCategory?.toUpperCase()));
      localStorage.setItem("NRIflag", NRIflag ? "true" : "false");
      //localStorage.setItem("userType", userType);
      const userInfo = getDecryptedItem("userInfo");
      if (userInfo?.nriFlag?.toUpperCase() === "TRUE") {
        localStorage.setItem("userType", "NRI-REPATRIABLE");
      }

    }

    let getallData = apiresponse?.data?.data;
    portfolioData = getData;
    getData.map((curr, index) => {
      indexFolioSchemeCode[`${curr.folioNo}_${curr.schemeCode}`] = curr;
      // indexSchemename[`${curr.folioNo}_${curr.schemeCode}`] = curr.schemeName;
      if (folioData.indexOf(curr.folioNo) === -1) {
        folioData.push(curr.folioNo);
      }
      if (MOHType.indexOf(curr.holdingMode) === -1) {
        MOHType.push(curr.holdingMode);
      }
      if (schemeCode.indexOf(curr.schemeCode) === -1) {
        portfoliodropDown.push({
          label: curr.schemeName,
          value: curr.schemeCode,
        });
        indexSchemename[`${curr.folioNo}_${curr.schemeCode}`] = curr.schemeName;
        schemeCode.push(curr.schemeCode);
      }
    });

    // folio type
    folioData.map((curr, index) => {
      let objdummy = [];
      let folioWiseholdingType = [];
      getData.forEach((element) => {
        if (curr === element.folioNo) {
          objdummy.push(element);
          if (folioWiseholdingType.indexOf(element.holdingMode) == -1) {
            folioWiseholdingType.push(element.holdingMode);
            foliowiseholdingtemp[element.folioNo] = element.holdingMode;
          }
        }
      });

      folioWiseData[curr] = objdummy;
      folioholdingType[curr] = folioWiseholdingType;
    });

    // schemeCodeWide folio
    schemeCode.map((curr, index) => {
      let schemeArray = [];
      let MOHtype = [];
      let dublicatScheme = [];
      getData.forEach((element) => {
        if (curr === element.schemeCode) {
          dublicatScheme.push(element);

          // "dematFolio": "Yes"
          if (schemeArray.indexOf(element.folioNo) == -1) {
            schemeArray.push(element.folioNo);

            // schemeArray.push(element.folioNo)
          }
          if (MOHtype.indexOf(element.holdingMode) == -1) {
            MOHtype.push(element.holdingMode);
          }
        }
      });
      schemeData[curr] = dublicatScheme;
      getuniqueschemeCode[curr] = schemeArray;
      MOHwiseFolio[curr] = MOHType;
    });
    let schemeWiseHolding = {};
    if (schemeCode.length > 0) {
      schemeCode.forEach((ele) => {
        let getdata = schemeData[ele];
        let holdingCust = [];
        if (getdata !== undefined) {
          getdata.map((curr, index) => {
            if (curr.schemeCode === ele) {
              if (holdingCust.indexOf(curr.holdingMode) == -1) {
                holdingCust.push(curr.holdingMode);
              }
            }
          });
          schemeWiseHolding[ele] = holdingCust;
        }
      });
    }
    let mohOBJData = {};
    MOHType.forEach((ele) => {
      let mofData = [];
      getData.map((curr) => {
        if (ele === curr.holdingMode) {
          mofData.push(curr);
        }
      });
      mohOBJData[ele] = mofData;
    });

    if (Object.keys(indexSchemename).length > 0) {
      for (const [key, value] of Object.entries(indexSchemename)) {
        prefillDropDown.push({ label: value, value: key });
      }
    }

    // yield put({ type: type.PORTFOLIO_DATA_SUCCESS, payload: {portfolioAll:getallData, dropdown: prefillDropDown, indexScheme: indexFolioSchemeCode, portfolioData: portfolioData, foliowiseScheme: folioholdingType, schemeWiseFolio: getuniqueschemeCode } })
    yield put({
      type: type.PORTFOLIO_DATA_SUCCESS,
      payload: {
        portfolioAll: getallData,
        dropdown: portfoliodropDown,
        indexScheme: indexFolioSchemeCode,
        portfolioData: portfolioData,
        foliowiseScheme: folioholdingType,
        schemeWiseFolio: getuniqueschemeCode,
        schemeData: schemeData,
        schemeWiseHolding: schemeWiseHolding,
        mohOBJData: mohOBJData,
      },
    });
  } else {
    // yield put({
    //     type: type.UPDATE_GUEST_MENU,
    // })
    yield put({
      type: type.PORTFOLIO_DATA_FAIL,
      payload: {
        portfolioAll: null,
        dropdown: prefillDropDown,
        indexScheme: indexFolioSchemeCode,
        portfolioData: portfolioData,
        schemeWiseHolding: null,
        mohOBJData: null,
      },
    });
  }

  //yield put({ type: NAV_SUCCESS, payload: })
}

function* fetchAllSchemeData(action) {
  let body = action.payload;
  console.log("GetAllScheme", action);
  // "apiName": "dashboard",
  let payload = {
    apiName: "GetAllScheme",
    ...body,
  };

  let apiresponse = yield call(fetchGet, payload);
  console.log(apiresponse, "GetAllScheme");
  let portSchemeData = {}; //singleschemeData

  //apiresponse = Dummy;
  if (apiresponse?.data?.success) {
    console.log("portfolio success", apiresponse?.data?.data);
    // if(apiresponse?.data?.data?.portfolios.length === 0){
    //     yield put({
    //         type: type.UPDATE_GUEST_MENU,
    //     })
    // }else{
    //     yield put({
    //         type: type.RESET_GUEST_MENU,
    //     })
    // }
    let getData = apiresponse?.data?.data?.schemes;


    portSchemeData = getData;
    console.log("portSchemeData==============>", portSchemeData);

    // yield put({ type: type.PORTFOLIO_DATA_SUCCESS, payload: {portfolioAll:getallData, dropdown: prefillDropDown, indexScheme: indexFolioSchemeCode, portfolioData: portfolioData, foliowiseScheme: folioholdingType, schemeWiseFolio: getuniqueschemeCode } })
    yield put({
      type: type.PORTFOLIO_ALL_DATA_SUCCESS,
      payload: {
        portSchemeData: portSchemeData
      },
    });
  } else {
    // yield put({
    //     type: type.UPDATE_GUEST_MENU,
    // })
    yield put({
      type: type.PORTFOLIO_ALL_DATA_FAIL,
      payload: {
        portSchemeData: portSchemeData
      },
    });
  }

  //yield put({ type: NAV_SUCCESS, payload: })
}

function* fetchFundCategoryNewData(action) {
  let body = action.payload;
  console.log("fetchFundCategoryNewData", action);
  // "apiName": "dashboard",
  let payload = {
    apiName: "FundCategoryNew",
    ...body,
  };

  let apiresponse = yield call(fetchFundCategory, payload);
  console.log(apiresponse, "FundCategoryNewResponse");
  let portSchemeData = {}; //singleschemeData

  //apiresponse = Dummy;
  if (apiresponse?.data?.success) {
    console.log("FundCategoryNew success", apiresponse?.data?.data);
    // if(apiresponse?.data?.data?.portfolios.length === 0){
    //     yield put({
    //         type: type.UPDATE_GUEST_MENU,
    //     })
    // }else{
    //     yield put({
    //         type: type.RESET_GUEST_MENU,
    //     })
    // }
    let getData = apiresponse?.data?.data;


    portSchemeData = getData;
    console.log("portSchemeData==============>", portSchemeData);

    // yield put({ type: type.PORTFOLIO_DATA_SUCCESS, payload: {portfolioAll:getallData, dropdown: prefillDropDown, indexScheme: indexFolioSchemeCode, portfolioData: portfolioData, foliowiseScheme: folioholdingType, schemeWiseFolio: getuniqueschemeCode } })
    yield put({
      type: type.FUNDCATEGORYNEW_ALL_DATA_SUCCESS,
      payload: {
        fundSchemeData: portSchemeData
      },
    });
  } else {
    // yield put({
    //     type: type.UPDATE_GUEST_MENU,
    // })
    yield put({
      type: type.FUNDCATEGORYNEW_ALL_DATA_FAIL,
      payload: {
        fundSchemeData: portSchemeData
      },
    });
  }

  //yield put({ type: NAV_SUCCESS, payload: })
}

export function* portFolioCall() {
  yield takeLatest(type.PORTFOLIO_DATA_PENDING, fetchData);
}

export function* portAllSchemeDataCall() {
  yield takeLatest(type.PORTFOLIO_ALL_DATA_PENDING, fetchAllSchemeData);
}

export function* getFundCategoryNew() {
  yield takeLatest(type.FUNDCATEGORYNEW_ALL_DATA_PENDING, fetchFundCategoryNewData);
}

export function* addToCart(data) {
  yield takeLatest(type.ADD_TO_CART_PENDING, callCartAPI);
}

function* callCartAPI(data) {
  let result = yield allApi.common(data.payload);
  if (result?.data?.success) {
    yield put({ type: type.ADD_TO_CART_SUCCESS, payload: data.body });
  } else {
    yield put({ type: type.ADD_TO_CART_FAILURE, payload: data.body });
  }
}

export function* singleCartData(data) {
  yield put({ type: type.SINGLE_CART_DATA, payload: data });
}

export function* getSipDashboard(data) {
  yield takeLatest(type.SIPDASHBOARD_PENDING, callSipDashboard);
}

function* callSipDashboard(data) {
  // yield put({ type: type.SIPDASHBOARD_PENDING })
  try{
  let result = yield allApi.common(data.payload);
  if (typeof result.data === "object") {
    if (result?.data?.success) {
      if (result?.data?.data?.status === "200") {
        let schPay = {
          api_name: "GetSchemeDetForSIPDashboard",
          data: result?.data?.data?.data,
        };
        // let resultSch = yield allApi.getSIPScheme(schPay);
        let resultSch = result?.data;
        // let resultSch = schemeDetForSIPDashboard;
        yield delay(100);
        let response = collectHoldingMode(resultSch, "SIP");
        let statementArr = [];
        let scheduleViewState = result?.data?.data?.scheduleViewSIP;
        let cancelViewState = result?.data?.data?.cancelSIPViewData;
        yield put({
          type: type.SIPDASHBOARD_SUCCESS,
          sipDashboardStatus: true,
          payload: resultSch.data,
          holdingMode: response.holdingMode,
          processMode: response.processMode,
          transStatus: response.transStatus,
          platformMode: response.platformMode,
          statementData: [...scheduleViewState, ...cancelViewState],
        });
      } else {
        yield put({
          type: type.SIPDASHBOARD_FAILURE,
          sipDashboardStatus: false,
          payload: result?.data?.data,
        });
      }
    } else {
      yield put({
        type: type.SIPDASHBOARD_FAILURE,
        sipDashboardStatus: false,
        payload: result?.data?.message,
      });
    }
  } else {
    if (result.hasOwnProperty("code") && result.code === 401) {
      yield put({
        type: type.SIPDASHBOARD_FAILURE,
        sipDashboardStatus: false,
        payload: "Logout",
      });
    }
    if (result.hasOwnProperty("code") && result.code === 400) {
      yield put({
        type: type.SIPDASHBOARD_FAILURE,
        swpDashboardStatus: false,
        payload: result?.data?.message,
      });
    } else {
      yield put({
        type: type.SIPDASHBOARD_FAILURE,
        sipDashboardStatus: false,
        payload: result?.data?.message,
      });
    }

  }
  } catch (error) {
    yield put({
      type: type.SIPDASHBOARD_FAILURE,
      sipDashboardStatus: false,
      payload: error?.message || "Something went wrong",
    });
  }
}

function* folioDescCall() {
  let payload = {
    apiName: "GetFolioDescription",
    body: {
      folioNo: "",
      schemeCode: "",
    },
  };
  let customData = {};
  let apires = yield allApi.common(payload);
  if (apires?.data?.success) {
    let getResult = apires?.data?.data;
    if (Object.keys(getResult).length > 0) {
      let foliod = getResult.folioDescs;
      if (foliod.length > 0) {
        foliod.map((curr, index) => {
          customData[curr.folioNo] = curr;
        });
      }
    }
    yield put({ type: type.FOLIODESC_SUCCESS, payload: customData });
  } else {
    yield put({ type: type.FOLIODESC_FAIL, payload: customData });
  }
}

export function* FolioDescription(data) {
  yield takeLatest(type.FOLIODESC_PENDING, folioDescCall);
}

export function* getSwpDashboard(data) {
  yield takeLatest(type.SWPDASHBOARD_PENDING, callSwpDashboard);
}

function* callSwpDashboard(data) {
  let result = yield allApi.common(data.payload);
  if (typeof result?.data === "object") {
    if (result?.data?.success) {
      if (result?.data?.data?.status === "200") {
        yield delay(100);
        let response = collectHoldingMode(result?.data, "SWP");
        yield put({
          type: type.SWPDASHBOARD_SUCCESS,
          swpDashboardStatus: true,
          payload: result?.data?.data,
          holdingMode: response.holdingMode,
          processMode: response.processMode,
          transStatus: response.transStatus,
        });
      } else {
        yield put({
          type: type.SWPDASHBOARD_FAILURE,
          swpDashboardStatus: false,
          payload: result?.data?.data,
        });
      }
    } else {
      yield put({
        type: type.SWPDASHBOARD_FAILURE,
        swpDashboardStatus: false,
        payload: result?.data?.message,
      });
    }
  } else {
    if (result.hasOwnProperty("code") && result.code === 401) {
      yield put({
        type: type.SWPDASHBOARD_FAILURE,
        swpDashboardStatus: false,
        payload: "Logout",
      });
    } else if (result.hasOwnProperty("code") && result.code === 400) {
      yield put({
        type: type.SWPDASHBOARD_FAILURE,
        swpDashboardStatus: false,
        payload: result?.data?.message,
      });
    } else {
      yield put({
        type: type.SWPDASHBOARD_FAILURE,
        swpDashboardStatus: false,
        payload: result?.data?.message,
      });
    }
  }
}

export function* getStpDashboard(data) {
  yield takeLatest(type.STPDASHBOARD_PENDING, callStpDashboard);
}

function* callStpDashboard(data) {
  let result = yield allApi.common(data.payload);
  if (typeof result?.data === "object") {
    if (result?.data?.success) {
      if (result?.data?.data?.status === "200") {
        yield delay(100);
        let response = collectHoldingMode(result?.data, "SWP");
        yield put({
          type: type.STPDASHBOARD_SUCCESS,
          stpDashboardStatus: true,
          payload: result?.data?.data,
          holdingMode: response.holdingMode,
          processMode: response.processMode,
          transStatus: response.transStatus,
        });
      } else {
        yield put({
          type: type.STPDASHBOARD_FAILURE,
          stpDashboardStatus: false,
          payload: result?.data?.data,
        });
      }
    } else {
      yield put({
        type: type.STPDASHBOARD_FAILURE,
        stpDashboardStatus: false,
        payload: result?.data?.message,
      });
    }
  } else {
    if (result.hasOwnProperty("code") && result.code === 401) {
      yield put({
        type: type.STPDASHBOARD_SUCCESS,
        stpDashboardStatus: false,
        payload: "Logout",
      });
    } else if (result.hasOwnProperty("code") && result.code === 400) {
      yield put({
        type: type.STPDASHBOARD_SUCCESS,
        swpDashboardStatus: false,
        payload: result.data.message,
      });
    } else {
      yield put({
        type: type.STPDASHBOARD_SUCCESS,
        stpDashboardStatus: false,
        payload: result?.data?.message,
      });
    }
  }
}

function collectHoldingMode(data, type) {
  let holdingMode = [];
  let processMode = [];
  let transStatus = [];
  let platformMode = [];
  if (type === "SIP") {
    if (data?.success) {
      if (data?.data?.data?.length > 0) {
        data?.data?.data?.map((curr, ind) => {
          if (holdingMode.indexOf(curr.sm_Mode) === -1) {
            holdingMode.push(curr.sm_Mode);
          }
          if (processMode.indexOf(curr.sM_Onlineoffline) === -1) {
            processMode.push(curr.sM_Onlineoffline);
          }
          if (transStatus.indexOf(curr.sm_status) === -1) {
            transStatus.push(curr.sm_status);
          }
          if (platformMode.indexOf(curr.dematChanelPerternar) == -1) {
            platformMode.push(curr.dematChanelPerternar)
          }
        });
      }
    }
  } else {
    if (data?.success) {
      if (data?.data?.data?.length > 0) {
        data?.data?.data?.map((curr, ind) => {
          if (holdingMode.indexOf(curr.modeofHolding) === -1) {
            holdingMode.push(curr.modeofHolding);
          }
          if (processMode.indexOf(curr.transactionMode) === -1) {
            processMode.push(curr.transactionMode);
          }
          if (transStatus.indexOf(curr.stpswpStatus) === -1) {
            transStatus.push(curr.stpswpStatus);
          }
        });
      }
    }
  }

  return {
    holdingMode: holdingMode,
    processMode: processMode,
    transStatus: transStatus,
    platformMode: platformMode
  };
}

function createDataSet() {
  // modeofHolding
}

export function* getAllFolios() {
  yield takeLatest(type.GET_ALL_FOLIOS, callZBFFolios);
}

function* callZBFFolios() {
  let foliolistpayload = {
    apiName: "getFolioList",
    body: {},
  };
  let apiresponseFolio = yield call(folioList, foliolistpayload);
  if (apiresponseFolio?.data?.success) {
    let arrayCheck = apiresponseFolio?.data?.data;
    yield put({ type: type.ZBF_FOLIO_SUCCESS, payload: arrayCheck });
  } else {
    yield put({ type: type.ZBF_FOLIO_FAIL, payload: [] });
  }
}

export function* getCartCount() {
  yield takeLatest(type.GET_CART_COUNT, callCartCount);
}

function* callCartCount(data) {
  let result = yield allApi.common(data.payload);
  if (result?.data?.success) {
    yield put({ type: type.GET_CART_COUNT_SUCCESS, payload: result?.data?.data });
  } else {
    yield put({
      type: type.GET_CART_COUNT_FAILURE,
      payload: result?.data?.message,
    });
  }
}
